const state = {
  pageConfig: [],
  extraFields: [],
  batchRowData: {},  // 编辑批次成功后通过批次id 查回来的批次数据
  orderRowData: {},  // 编辑订单成功通过订单id 查回来的订单数据
  manualTrackingNumbers: [],
  orderListTable: [], // 订单列表的tableData（理论上应该取代项目中的tableData，由于代码量已经太大，暂时分离出来）
  orderListConditions: {}, // 订单列表的搜索条件
  orderListSearchMore: false, // 订单列表搜索条件是否展开
  isYiXunDa: false,
  saveid:'',
  savebatchList:[], // 存放箱数点击详情列表 （有可能数据比较多）
  saveyitiqulist:[],
  saveqslist:[],
  savewqslist:[]
}

export default state


// WEBPACK FOOTER //
// ./src/store/state.js